import Request from '../../../app/utilities/Request';
import PlaidTransaction from '../../models/PlaidTransaction';
import { TOGGLE_SHOW_HIDDEN_BANK_TRANSACTIONS } from "./dashboard";
import { GROCERY_LIST_ITEM_REORDER, saveGroceryList } from "./calendar.js";
import { isInstitutionVisible, isClosedAccount, visibleMoveToFullMove } from "../../utilities/closedAccounts.js";

export const RETRIEVE_PLAID_ACCOUNTS_BEGIN = 'RETRIEVE_PLAID_ACCOUNTS_BEGIN';
export const RETRIEVE_PLAID_ACCOUNTS_SUCCESS = 'RETRIEVE_PLAID_ACCOUNTS_SUCCESS';
export const RETRIEVE_PLAID_ACCOUNTS_FAIL = 'RETRIEVE_PLAID_ACCOUNTS_FAIL';

export const RETRIEVE_PLAID_TRANSACTIONS_BEGIN = 'RETRIEVE_PLAID_TRANSACTIONS_BEGIN';
export const RETRIEVE_PLAID_TRANSACTIONS_SUCCESS = 'RETRIEVE_PLAID_TRANSACTIONS_SUCCESS';
export const RETRIEVE_PLAID_TRANSACTIONS_FAIL = 'RETRIEVE_PLAID_TRANSACTIONS_FAIL';

export const TOGGLE_SHOW_BANK_ACCOUNT_TRANSACTIONS = 'TOGGLE_SHOW_BANK_ACCOUNT_TRANSACTIONS';

export const START_SHOW_BANKS = 'START_SHOW_BANKS';
export const END_SHOW_BANKS = 'END_SHOW_BANKS';

export const PLAID_INSTITUTION_REORDER = 'PLAID_INSTITUTION_REORDER';
export const PLAID_INNER_ACCOUNT_REORDER = 'PLAID_INNER_ACCOUNT_REORDER';
export const TOGGLE_SHOW_CLOSED_ACCOUNTS = 'TOGGLE_SHOW_CLOSED_ACCOUNTS';

export const toggleShowClosedAccounts = () => ({
	type: TOGGLE_SHOW_CLOSED_ACCOUNTS
});

export const TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_BEGIN = 'TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_BEGIN';
export const TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_SUCCESS = 'TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_SUCCESS';
export const TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_FAIL = 'TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_FAIL';

export const toggledAddedToTotalAssetsForAccount = (accountId, setTo) => (dispatch) => {
	dispatch({
		type: TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_BEGIN
	});
	const data = {
		account_id: accountId,
		set: setTo
	};
	return Request.apiv1Post('plaid_account/set_added_to_total_assets_for_account', data)
		.then((response) => {
			dispatch({
				type: TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_SUCCESS,
				payload: response.accounts
			});
		})
		.catch((error) => {
			dispatch({
				type: TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_FAIL
			});
			throw error;
		})
		.catch(Request.generalJsonError)
		.finally(() => {

		});
};

/** `startIndex` and `endIndex` are positions on screen, where hidden institutions take none. */
export const plaidInstitutionDrag = (startIndex, endIndex) => (dispatch, getState) => {
	const { showClosedAccounts, plaidAccountsRaw: institutions } = getState().plaid;
	const move = visibleMoveToFullMove(institutions, (institution) => isInstitutionVisible(institution, showClosedAccounts), startIndex, endIndex);
	dispatch({
		type: PLAID_INSTITUTION_REORDER,
		payload: move
	});
	const { plaidAccountsRaw } = getState().plaid;
	const order = [];
	plaidAccountsRaw.forEach((plaidAccount) => {
		order.push(plaidAccount.id);
	});
	Request.apiv1Post('plaid/save_institution_order', { order })
		.then((response) => {

		});
};

/** `startIndex` and `endIndex` are positions on screen, where hidden accounts take none. */
export const plaidInnerAccountDrag = (userInstitutionId, startIndex, endIndex) => (dispatch, getState) => {
	function getSelectedInstitutionAccount() {
		const { plaidAccountsRaw } = getState().plaid;
		const selectedPlaidInstitutionAccount = plaidAccountsRaw.find((plaidAccount) => {
			return plaidAccount.id === userInstitutionId;
		});
		if(!selectedPlaidInstitutionAccount) {
			throw new Error('Account with id not found');
		}
		return selectedPlaidInstitutionAccount;
	}

	let selectedPlaidInstitutionAccount = getSelectedInstitutionAccount();
	const { showClosedAccounts } = getState().plaid;
	const move = visibleMoveToFullMove(selectedPlaidInstitutionAccount.accounts, (account) => showClosedAccounts || !isClosedAccount(account), startIndex, endIndex);
	dispatch({
		type: PLAID_INNER_ACCOUNT_REORDER,
		payload: {
			selectedPlaidInstitutionAccount,
			...move
		}
	});
	const order = [];
	selectedPlaidInstitutionAccount = getSelectedInstitutionAccount();//Should be a new reference now
	selectedPlaidInstitutionAccount.accounts.forEach((innerBankAccount) => {
		order.push(innerBankAccount.id);
	});
	Request.apiv1Post('plaid/save_bank_account_order', { order })
		.then((response) => {

		});
};

export const retrieveBankTransactions = (selectedDate) => (dispatch, getState) => {
	const data = {
		month: selectedDate.month() + 1,
		year: selectedDate.year()
	};

	const { transactionFinder } = getState().dashboard;

	if(transactionFinder.plaidTransactions.hasMonthBeenRetrieved(data.year, data.month)) {
		return;
	}

	dispatch({
		type: RETRIEVE_PLAID_TRANSACTIONS_BEGIN,
		payload: {
			month: data.month,
			year: data.year,
		}
	});

	Request.apiv1Get('plaid/transactions', data)
		.then((response) => {
			dispatch({
				type: RETRIEVE_PLAID_TRANSACTIONS_SUCCESS,
				payload: {
					month: data.month,
					year: data.year,
					transactions: response.transactions.map((transaction) => {
						return PlaidTransaction.create(transaction);
					}),
					transactionFinder,
				}
			});
		})
		.catch((error) => {
			console.error(error);
			dispatch({
				type: RETRIEVE_PLAID_TRANSACTIONS_FAIL,
				payload: {
					month: data.month,
					year: data.year,
				}
			});
		});
};

export const endShowBanks = () => {
	return {
		type: END_SHOW_BANKS
	};
};
export const startShowBanks = () => {
	return {
		type: START_SHOW_BANKS
	};
};
export const retrievePlaidAccounts = () => (dispatch, getState) => {
	dispatch({
		type: RETRIEVE_PLAID_ACCOUNTS_BEGIN
	});

	Request.apiv1Get('plaid/accounts')
		.then((response) => {
			dispatch({
				type: RETRIEVE_PLAID_ACCOUNTS_SUCCESS,
				payload: response.accounts
			});
		})
		.catch((error) => {
			console.error(error);
			dispatch({
				type: RETRIEVE_PLAID_ACCOUNTS_FAIL
			});
		});
};

export const toggleShowBankAccountTransactions = () => (dispatch, getState) => {
	dispatch({
		type: TOGGLE_SHOW_BANK_ACCOUNT_TRANSACTIONS
	});
	dispatch(retrieveBankAccountTransactionsIfNecessary());
};

export const toggleShowHiddenBankAccountTransactions = () => {
	return {
		type: TOGGLE_SHOW_HIDDEN_BANK_TRANSACTIONS
	};
};

export const retrieveBankAccountTransactionsIfNecessary = () => (dispatch, getState) => {
	const { showingBankAccountTransactionsWithinTransactions } = getState().plaid;
	const { selectedDate } = getState().dashboard;
	const { selectedMainTab } = getState().url;
	if(selectedMainTab !== 'transactions') {
		return;
	}
	if(!selectedDate) {
		console.error('attempted to toggle while selected date is unknown');
		return;
	}
	if(showingBankAccountTransactionsWithinTransactions) {
		dispatch(retrieveBankTransactions(selectedDate));
	}
};